export default __webpack_public_path__ + "static/media/arrow-left-blue.fbfeb02c.svg";